import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ssn'})
export class SsnPipe implements PipeTransform  {
    private _pattern = /^(.{3})(.{2})(.{4})$/;

    public transform(value: any) {
        if (null == value) {
            return null;
        }

        var match = this._pattern.exec(value);

        if ((null != match) && (4 == match.length)) {
            return `${match[1]}-${match[2]}-${match[3]}`;
        }

        return value;
    }
}
